import { useSetRecoilState } from 'recoil'
import { languageStore } from './languageStore'
const useLanguageStoreFunction = () => {
    const setLanguage = useSetRecoilState(languageStore)

    const setCurrentLanguage = (key: string) => {
        setLanguage((prevState) => ({
            ...prevState,
            currentLanguage: key,
        }))
    }

    return {
        setCurrentLanguage,
    }
}

export default useLanguageStoreFunction
